import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <AppBar position="sticky" sx={{ backgroundColor: '#F5EEDC' }}>
      <Toolbar sx={{ justifyContent: 'space-between' }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <img src="/img/costpng.png" alt="Company Logo" style={{ height: '50px' }} />



</Box>

        <Box>
          <Button component={Link} to="/" sx={{ color: '#27548A', mx: 1 }}>
            Home
          </Button>
          <Button component={Link} to="/about" sx={{ color: '#27548A', mx: 1 }}>
            About
          </Button>
          <Button component={Link} to="/services" sx={{ color: '#27548A', mx: 1 }}>
            Services
          </Button>
          <Button component={Link} to="/pricing" sx={{ color: '#27548A', mx: 1 }}>
            Pricing
          </Button>
          <Button component={Link} to="/contact" sx={{ color: '#27548A', mx: 1 }}>
            Contact
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
